export default {
  router: [
    {
      exact: true,
      path: '/setting/accountManagement',
      title: '子账号管理',
    },
  ],
  title: '子账号管理',
};
